import React, { useState, useEffect, useRef } from 'react';

const API = process.env.REACT_APP_API_URL || '';
const G = { bg:'#0d0d0d', surface:'#141414', border:'#1e1e1e', accent:'#C8FF00', muted:'#555', text:'#EAEAEA', orange:'#FF4D1C' };

const btn = (color='#C8FF00', disabled=false) => ({
  background: disabled ? '#1e1e1e' : color,
  color: disabled ? '#444' : (color === '#C8FF00' ? '#000' : '#fff'),
  border: 'none', borderRadius: 8, padding: '10px 20px',
  fontSize: '0.82rem', fontWeight: 700, cursor: disabled ? 'default' : 'pointer',
  opacity: disabled ? 0.5 : 1, transition: 'all 0.15s',
});

const inp = {
  background: '#0d0d0d', border: '1px solid #222', borderRadius: 8,
  color: '#EAEAEA', padding: '10px 14px', fontSize: '0.85rem',
  width: '100%', boxSizing: 'border-box', outline: 'none',
};

const card = { background: G.surface, border: `1px solid ${G.border}`, borderRadius: 12, padding: 20, marginBottom: 12 };

/* ─── Parser CSV simple (colonnes séparées par , ou ;) ─── */
function parseCSV(text) {
  const lines = text.trim().split(/\r?\n/).filter(Boolean);
  if (lines.length < 2) return [];
  const sep = lines[0].includes(';') ? ';' : ',';
  const headers = lines[0].split(sep).map(h => h.replace(/["']/g, '').trim().toLowerCase());
  return lines.slice(1).map(line => {
    const vals = line.split(sep).map(v => v.replace(/["']/g, '').trim());
    const obj = {};
    headers.forEach((h, i) => { obj[h] = vals[i] || ''; });
    return obj;
  }).filter(r => r.email || r['e-mail'] || r.courriel);
}

/* ══════════ ONGLET ABONNÉS ══════════ */
function OngletAbonnes() {
  const [subs, setSubs]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch]   = useState('');
  const [msg, setMsg]         = useState('');

  useEffect(() => {
    fetch(`${API}/api/marketing/subscribers`, { credentials:'include' })
      .then(r => r.json()).then(setSubs).finally(() => setLoading(false));
  }, []);

  const filtered = subs.filter(s =>
    !search || s.email?.includes(search) || s.name?.toLowerCase().includes(search.toLowerCase()) || s.list?.toLowerCase().includes(search.toLowerCase())
  );

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer cet abonné ?')) return;
    await fetch(`${API}/api/marketing/subscribers/${id}`, { method:'DELETE', credentials:'include' });
    setSubs(s => s.filter(x => x.id !== id));
  };

  const exportCSV = () => {
    const rows = [['Email','Nom','Liste','Source','Actif','Date'].join(','),
      ...filtered.map(s => [s.email, s.name||'', s.list||'', s.source||'', s.active?'Oui':'Non', s.createdAt?.slice(0,10)||''].join(','))
    ];
    const a = document.createElement('a');
    a.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(rows.join('\n'));
    a.download = `abonnes-${Date.now()}.csv`;
    a.click();
  };

  return (
    <div>
      <div style={{ display:'flex', gap:12, marginBottom:20, alignItems:'center', flexWrap:'wrap' }}>
        <input placeholder="Rechercher..." value={search} onChange={e=>setSearch(e.target.value)} style={{ ...inp, maxWidth:280 }} />
        <button onClick={exportCSV} style={btn('#1e1e1e')}>⬇ Exporter CSV</button>
        <span style={{ color:G.muted, fontSize:'0.8rem', marginLeft:'auto' }}>{filtered.length} / {subs.length} abonnés</span>
      </div>

      {loading ? <p style={{ color:G.muted }}>Chargement…</p> : (
        <div style={{ overflowX:'auto' }}>
          <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'0.82rem' }}>
            <thead>
              <tr style={{ borderBottom:`1px solid ${G.border}` }}>
                {['Email','Nom','Liste','Source','Statut','Date',''].map(h => (
                  <th key={h} style={{ textAlign:'left', padding:'8px 12px', color:G.muted, fontWeight:600 }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map(s => (
                <tr key={s.id} style={{ borderBottom:`1px solid #111` }}>
                  <td style={{ padding:'8px 12px', color:G.text }}>{s.email}</td>
                  <td style={{ padding:'8px 12px', color:'#888' }}>{s.name||'—'}</td>
                  <td style={{ padding:'8px 12px' }}>
                    <span style={{ background:'rgba(200,255,0,0.08)', color:G.accent, borderRadius:4, padding:'2px 8px', fontSize:'0.75rem', fontWeight:700 }}>{s.list||'—'}</span>
                  </td>
                  <td style={{ padding:'8px 12px', color:'#555', fontSize:'0.75rem' }}>{s.source||'—'}</td>
                  <td style={{ padding:'8px 12px' }}>
                    <span style={{ color: s.active ? '#4ade80' : '#f87171', fontWeight:700, fontSize:'0.75rem' }}>{s.active ? '● Actif' : '○ Inactif'}</span>
                  </td>
                  <td style={{ padding:'8px 12px', color:'#555', fontSize:'0.75rem' }}>{s.createdAt?.slice(0,10)||'—'}</td>
                  <td style={{ padding:'8px 12px' }}>
                    <button onClick={() => handleDelete(s.id)} style={{ background:'none', border:'none', color:'#f87171', cursor:'pointer', fontSize:'0.8rem' }}>✕</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {filtered.length === 0 && <p style={{ color:G.muted, textAlign:'center', padding:32 }}>Aucun abonné.</p>}
        </div>
      )}
    </div>
  );
}

/* ══════════ ONGLET IMPORTER ══════════ */
function OngletImporter({ onImported }) {
  const [preview, setPreview]   = useState([]);
  const [listName, setListName] = useState('');
  const [fileName, setFileName] = useState('');
  const [loading, setLoading]   = useState(false);
  const [msg, setMsg]           = useState('');
  const fileRef = useRef();

  const handleFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setFileName(file.name);
    setListName(file.name.replace(/\.[^.]+$/, ''));
    const reader = new FileReader();
    reader.onload = (ev) => {
      const contacts = parseCSV(ev.target.result);
      setPreview(contacts.slice(0, 5));
      sessionStorage.setItem('_importContacts', JSON.stringify(contacts));
      setMsg(`${contacts.length} contacts détectés.`);
    };
    reader.readAsText(file, 'UTF-8');
  };

  const handleImport = async () => {
    const contacts = JSON.parse(sessionStorage.getItem('_importContacts') || '[]');
    if (!contacts.length) return;
    setLoading(true);
    try {
      const r = await fetch(`${API}/api/marketing/import`, {
        method:'POST', credentials:'include',
        headers:{ 'Content-Type':'application/json' },
        body: JSON.stringify({ contacts, listName }),
      });
      const data = await r.json();
      setMsg(`✓ ${data.imported} contacts importés dans "${data.list}".`);
      setPreview([]); setFileName('');
      sessionStorage.removeItem('_importContacts');
      onImported?.();
    } catch (e) {
      setMsg('Erreur lors de l\'import.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div style={card}>
        <p style={{ color:G.muted, fontSize:'0.85rem', marginTop:0, marginBottom:16 }}>
          Importez un fichier <strong style={{ color:G.text }}>CSV</strong> (colonnes : email, nom, téléphone, entreprise, tags). Si vous avez un fichier Excel, enregistrez-le d'abord en CSV depuis Excel (Fichier → Enregistrer sous → CSV UTF-8).
        </p>
        <div style={{ display:'flex', gap:12, alignItems:'center', flexWrap:'wrap' }}>
          <input ref={fileRef} type="file" accept=".csv,.txt" onChange={handleFile} style={{ display:'none' }} />
          <button onClick={() => fileRef.current.click()} style={btn()}>📁 Choisir un fichier CSV</button>
          {fileName && <span style={{ color:G.accent, fontSize:'0.82rem' }}>{fileName}</span>}
        </div>
      </div>

      {preview.length > 0 && (
        <div style={card}>
          <div style={{ display:'flex', gap:12, alignItems:'center', marginBottom:16, flexWrap:'wrap' }}>
            <div style={{ flex:1 }}>
              <label style={{ color:G.muted, fontSize:'0.75rem', display:'block', marginBottom:4 }}>NOM DE LA LISTE</label>
              <input value={listName} onChange={e=>setListName(e.target.value)} style={{ ...inp, maxWidth:320 }} placeholder="Ex: Clients 2025" />
            </div>
          </div>
          <p style={{ color:G.muted, fontSize:'0.8rem', marginBottom:8 }}>Aperçu des 5 premiers contacts :</p>
          <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'0.8rem' }}>
            <thead>
              <tr style={{ borderBottom:`1px solid ${G.border}` }}>
                {Object.keys(preview[0]).slice(0,5).map(h => (
                  <th key={h} style={{ textAlign:'left', padding:'6px 10px', color:G.muted, fontWeight:600, textTransform:'uppercase', fontSize:'0.7rem' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {preview.map((row, i) => (
                <tr key={i} style={{ borderBottom:'1px solid #111' }}>
                  {Object.values(row).slice(0,5).map((v,j) => (
                    <td key={j} style={{ padding:'6px 10px', color:G.text }}>{v||'—'}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{ marginTop:16, display:'flex', gap:12, alignItems:'center' }}>
            <button onClick={handleImport} disabled={loading} style={btn(G.orange, loading)}>
              {loading ? 'Import en cours…' : '⬆ Importer la liste'}
            </button>
          </div>
        </div>
      )}

      {msg && <p style={{ color: msg.startsWith('✓') ? '#4ade80' : G.orange, fontSize:'0.85rem', marginTop:12 }}>{msg}</p>}
    </div>
  );
}

/* ══════════ TEMPLATES EMAIL ══════════ */
const TEMPLATES = [
  {
    id: 'promo',
    label: '🎯 Offre exclusive',
    color: '#FF4D1C',
    subject: '🎯 Une offre spéciale rien que pour vous',
    body: `<div style="font-family:Arial,sans-serif;max-width:560px;margin:0 auto">
  <div style="background:linear-gradient(135deg,#FF4D1C,#ff7a4d);padding:40px 32px;border-radius:16px 16px 0 0;text-align:center">
    <p style="margin:0 0 8px;font-size:11px;font-weight:800;letter-spacing:4px;color:rgba(255,255,255,0.7);text-transform:uppercase">OFFRE LIMITÉE</p>
    <h1 style="margin:0;font-size:32px;font-weight:900;color:#fff;line-height:1.2">Une offre exclusive<br/>rien que pour vous</h1>
  </div>
  <div style="background:#fff;padding:40px 32px;border-radius:0 0 16px 16px;border:1px solid #f0f0f0;border-top:none">
    <p style="color:#333;font-size:15px;line-height:1.7;margin:0 0 24px">Bonjour,</p>
    <p style="color:#333;font-size:15px;line-height:1.7;margin:0 0 24px">
      Nous avons une <strong>offre spéciale</strong> réservée à nos clients fidèles. Profitez-en avant qu'elle expire !
    </p>
    <div style="background:#fff8f6;border:2px dashed #FF4D1C;border-radius:12px;padding:24px;text-align:center;margin:0 0 32px">
      <p style="margin:0 0 4px;font-size:13px;color:#FF4D1C;font-weight:700;text-transform:uppercase;letter-spacing:2px">Votre avantage exclusif</p>
      <p style="margin:0;font-size:28px;font-weight:900;color:#111">Décrivez votre offre ici</p>
    </div>
    <div style="text-align:center;margin:0 0 32px">
      <a href="https://axispme.ca/#contact" style="display:inline-block;background:#FF4D1C;color:#fff;text-decoration:none;padding:16px 40px;border-radius:50px;font-weight:800;font-size:15px;letter-spacing:0.5px">
        Profiter de l'offre →
      </a>
    </div>
    <p style="color:#999;font-size:13px;line-height:1.6;margin:0">Des questions ? Répondez directement à ce courriel ou appelez-nous au <strong>514-914-9110</strong>.</p>
  </div>
</div>`,
  },
  {
    id: 'newsletter',
    label: '📰 Infolettre',
    color: '#2563eb',
    subject: '📰 Nos nouveautés — [Mois Année]',
    body: `<div style="font-family:Arial,sans-serif;max-width:560px;margin:0 auto">
  <div style="background:#0f172a;padding:32px;border-radius:16px 16px 0 0;display:flex;align-items:center;gap:12px">
    <div style="width:36px;height:36px;background:linear-gradient(135deg,#FF4D1C,#ff7a4d);border-radius:8px;display:flex;align-items:center;justify-content:center;font-weight:900;color:#fff;font-size:16px;flex-shrink:0">A</div>
    <div>
      <p style="margin:0;font-size:14px;font-weight:800;color:#fff;letter-spacing:2px">AXISPME</p>
      <p style="margin:0;font-size:10px;color:#64748b;letter-spacing:1px;text-transform:uppercase">Infolettre</p>
    </div>
  </div>
  <div style="background:#fff;padding:40px 32px;border:1px solid #e2e8f0;border-top:none">
    <p style="margin:0 0 4px;font-size:11px;font-weight:700;letter-spacing:3px;color:#2563eb;text-transform:uppercase">Nouveautés</p>
    <h1 style="margin:0 0 24px;font-size:26px;font-weight:900;color:#0f172a;line-height:1.3">Ce qui se passe chez Axispme ce mois-ci</h1>
    <hr style="border:none;border-top:1px solid #f1f5f9;margin:0 0 24px"/>
    <h2 style="margin:0 0 8px;font-size:16px;font-weight:800;color:#0f172a">📌 Titre de la nouvelle #1</h2>
    <p style="color:#475569;font-size:14px;line-height:1.7;margin:0 0 24px">Décrivez votre première actualité ici. Partagez une réussite client, un nouveau service ou un conseil utile pour vos lecteurs.</p>
    <hr style="border:none;border-top:1px solid #f1f5f9;margin:0 0 24px"/>
    <h2 style="margin:0 0 8px;font-size:16px;font-weight:800;color:#0f172a">🚀 Titre de la nouvelle #2</h2>
    <p style="color:#475569;font-size:14px;line-height:1.7;margin:0 0 32px">Deuxième actualité. Gardez un ton simple, direct et utile pour vos abonnés.</p>
    <div style="text-align:center">
      <a href="https://axispme.ca" style="display:inline-block;background:#0f172a;color:#fff;text-decoration:none;padding:14px 36px;border-radius:50px;font-weight:800;font-size:14px">
        Visiter notre site →
      </a>
    </div>
  </div>
  <div style="background:#f8fafc;padding:20px 32px;border-radius:0 0 16px 16px;border:1px solid #e2e8f0;border-top:none;text-align:center">
    <p style="margin:0;color:#94a3b8;font-size:12px">© Axispme · Agence Ucreative inc. · <a href="https://axispme.ca" style="color:#2563eb">axispme.ca</a></p>
  </div>
</div>`,
  },
  {
    id: 'relance',
    label: '👋 Relance client',
    color: '#059669',
    subject: '👋 On pense à votre projet',
    body: `<div style="font-family:Arial,sans-serif;max-width:560px;margin:0 auto">
  <div style="background:#ecfdf5;border:1px solid #a7f3d0;border-radius:16px;padding:40px 32px;text-align:center;margin-bottom:0">
    <div style="width:64px;height:64px;background:linear-gradient(135deg,#059669,#34d399);border-radius:50%;margin:0 auto 20px;display:flex;align-items:center;justify-content:center;font-size:28px">👋</div>
    <h1 style="margin:0 0 12px;font-size:26px;font-weight:900;color:#064e3b;line-height:1.3">On pense à votre projet</h1>
    <p style="margin:0;color:#047857;font-size:14px">Il y a un moment qu'on n'a pas eu de vos nouvelles</p>
  </div>
  <div style="background:#fff;padding:40px 32px;border:1px solid #e2e8f0;border-top:none;border-radius:0 0 16px 16px">
    <p style="color:#374151;font-size:15px;line-height:1.8;margin:0 0 20px">Bonjour,</p>
    <p style="color:#374151;font-size:15px;line-height:1.8;margin:0 0 20px">
      Nous pensons souvent à nos anciens clients et nous demandons si vous avez de nouveaux <strong>projets web, de branding ou de marketing digital</strong> en tête.
    </p>
    <p style="color:#374151;font-size:15px;line-height:1.8;margin:0 0 32px">
      Nous serions ravis de collaborer à nouveau avec vous. Que ce soit pour une refonte de site, un nouveau logo ou une campagne, notre équipe est disponible.
    </p>
    <div style="background:#f0fdf4;border-left:4px solid #059669;border-radius:0 8px 8px 0;padding:20px 24px;margin:0 0 32px">
      <p style="margin:0;font-size:14px;color:#065f46;font-weight:700">💡 Astuce gratuite du mois</p>
      <p style="margin:8px 0 0;font-size:14px;color:#047857;line-height:1.6">Ajoutez votre conseil ou astuce ici — une valeur ajoutée qui incite le client à vous répondre.</p>
    </div>
    <div style="text-align:center">
      <a href="https://axispme.ca/#contact" style="display:inline-block;background:#059669;color:#fff;text-decoration:none;padding:16px 40px;border-radius:50px;font-weight:800;font-size:15px">
        Parlons de votre projet →
      </a>
    </div>
    <p style="color:#9ca3af;font-size:13px;text-align:center;margin:24px 0 0">ou appelez-nous directement : <strong style="color:#374151">514-914-9110</strong></p>
  </div>
</div>`,
  },
];

/* ══════════ ONGLET CAMPAGNE ══════════ */
function OngletCampagne() {
  const [lists, setLists]         = useState([]);
  const [selLists, setSelLists]   = useState([]);
  const [subject, setSubject]     = useState('');
  const [body, setBody]           = useState('');
  const [senderName, setSender]   = useState('Axispme');
  const [sending, setSending]     = useState(false);
  const [msg, setMsg]             = useState('');
  const [selTpl, setSelTpl]       = useState('');

  useEffect(() => {
    fetch(`${API}/api/marketing/lists`, { credentials:'include' })
      .then(r => r.json()).then(setLists).catch(() => {});
  }, []);

  const toggleList = (name) => setSelLists(s => s.includes(name) ? s.filter(x=>x!==name) : [...s, name]);

  const applyTemplate = (tpl) => {
    setSelTpl(tpl.id);
    setSubject(tpl.subject);
    setBody(tpl.body);
  };

  const handleSend = async () => {
    if (!subject.trim() || !body.trim() || selLists.length === 0) {
      setMsg('⚠ Sujet, corps et au moins une liste requis.'); return;
    }
    setSending(true); setMsg('');
    try {
      const r = await fetch(`${API}/api/marketing/send`, {
        method:'POST', credentials:'include',
        headers:{ 'Content-Type':'application/json' },
        body: JSON.stringify({ subject, body, lists: selLists, senderName }),
      });
      const data = await r.json();
      if (!r.ok) throw new Error(data.error);
      setMsg(`✓ Campagne lancée — ${data.total} courriels en cours d'envoi.`);
      setSubject(''); setBody(''); setSelLists([]); setSelTpl('');
    } catch (e) {
      setMsg('✗ Erreur : ' + e.message);
    } finally {
      setSending(false);
    }
  };

  const totalDest = lists.filter(l => selLists.includes(l.name)).reduce((a,l) => a + l.count, 0);

  return (
    <div>
      {/* 3 Templates */}
      <div style={{ marginBottom:20 }}>
        <label style={{ color:G.muted, fontSize:'0.75rem', display:'block', marginBottom:12, letterSpacing:1, textTransform:'uppercase' }}>Choisir un template</label>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:12 }}>
          {TEMPLATES.map(tpl => (
            <button key={tpl.id} onClick={() => applyTemplate(tpl)} style={{
              background: selTpl === tpl.id ? `${tpl.color}14` : '#111',
              border: `1.5px solid ${selTpl === tpl.id ? tpl.color : '#1e1e1e'}`,
              borderRadius:12, padding:'16px 14px', cursor:'pointer', textAlign:'left', transition:'all 0.15s',
            }}>
              <div style={{ fontSize:'0.8rem', fontWeight:800, color: selTpl === tpl.id ? tpl.color : G.text, marginBottom:4 }}>{tpl.label}</div>
              <div style={{ fontSize:'0.72rem', color:G.muted, lineHeight:1.4 }}>
                {tpl.id === 'promo'      && 'Promotion, offre limitée, réduction'}
                {tpl.id === 'newsletter' && 'Actualités, conseils, nouveautés'}
                {tpl.id === 'relance'    && 'Réengager un client inactif'}
              </div>
              {selTpl === tpl.id && <div style={{ marginTop:8, fontSize:'0.7rem', color:tpl.color, fontWeight:700 }}>✓ Sélectionné</div>}
            </button>
          ))}
        </div>
      </div>

      {/* Expéditeur + Listes côte à côte */}
      <div style={{ display:'grid', gridTemplateColumns:'1fr 2fr', gap:12, marginBottom:12 }}>
        <div style={card}>
          <label style={{ color:G.muted, fontSize:'0.75rem', display:'block', marginBottom:6, textTransform:'uppercase', letterSpacing:1 }}>Expéditeur</label>
          <input value={senderName} onChange={e=>setSender(e.target.value)} style={{ ...inp, marginBottom:6 }} placeholder="Axispme" />
          <p style={{ color:'#444', fontSize:'0.72rem', margin:0 }}>info@axispme.ca</p>
        </div>
        <div style={card}>
          <label style={{ color:G.muted, fontSize:'0.75rem', display:'block', marginBottom:10, textTransform:'uppercase', letterSpacing:1 }}>Listes destinataires</label>
          {lists.length === 0
            ? <p style={{ color:G.muted, fontSize:'0.82rem', margin:0 }}>Aucune liste. Importez des contacts d'abord.</p>
            : <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                {lists.map(l => (
                  <button key={l.name} onClick={() => toggleList(l.name)} style={{
                    padding:'6px 14px', borderRadius:20, fontSize:'0.8rem', fontWeight:700, cursor:'pointer',
                    background: selLists.includes(l.name) ? `${G.accent}18` : '#0d0d0d',
                    border: `1px solid ${selLists.includes(l.name) ? G.accent : '#2a2a2a'}`,
                    color: selLists.includes(l.name) ? G.accent : '#555', transition:'all 0.15s',
                  }}>
                    {l.name} <span style={{ opacity:0.6 }}>({l.count})</span>
                  </button>
                ))}
              </div>
          }
        </div>
      </div>

      {/* Sujet */}
      <div style={{ marginBottom:12 }}>
        <label style={{ color:G.muted, fontSize:'0.75rem', display:'block', marginBottom:4, textTransform:'uppercase', letterSpacing:1 }}>Sujet</label>
        <input value={subject} onChange={e=>setSubject(e.target.value)} style={inp} placeholder="Ex: Nouvelle offre exclusive pour nos clients" />
      </div>

      {/* Corps */}
      <div style={{ marginBottom:16 }}>
        <label style={{ color:G.muted, fontSize:'0.75rem', display:'block', marginBottom:4, textTransform:'uppercase', letterSpacing:1 }}>Corps du courriel (HTML)</label>
        <textarea value={body} onChange={e=>setBody(e.target.value)}
          rows={12} style={{ ...inp, resize:'vertical', lineHeight:1.6, fontFamily:'monospace', fontSize:'0.78rem' }} />
      </div>

      <div style={{ display:'flex', gap:12, alignItems:'center', flexWrap:'wrap' }}>
        <button onClick={handleSend} disabled={sending} style={{
          ...btn(G.orange, sending),
          padding:'12px 28px', fontSize:'0.9rem',
          boxShadow: sending ? 'none' : '0 4px 20px rgba(255,77,28,0.3)',
        }}>
          {sending ? '⟳ Envoi en cours…' : `📨 Envoyer la campagne`}
        </button>
        {totalDest > 0 && (
          <span style={{ color:G.muted, fontSize:'0.82rem' }}>
            → <strong style={{ color:G.text }}>{totalDest}</strong> destinataires
          </span>
        )}
      </div>

      {msg && (
        <div style={{
          marginTop:16, padding:'14px 18px',
          background: msg.startsWith('✓') ? 'rgba(74,222,128,0.07)' : 'rgba(248,113,113,0.07)',
          border: `1px solid ${msg.startsWith('✓') ? '#4ade8040' : '#f8717140'}`,
          borderRadius:10, color: msg.startsWith('✓') ? '#4ade80' : '#f87171',
          fontSize:'0.85rem', fontWeight:600,
        }}>{msg}</div>
      )}
    </div>
  );
}

/* ══════════ ONGLET HISTORIQUE ══════════ */
function OngletHistorique() {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading]     = useState(true);

  useEffect(() => {
    fetch(`${API}/api/marketing/campaigns`, { credentials:'include' })
      .then(r => r.json()).then(setCampaigns).finally(() => setLoading(false));
  }, []);

  const statusStyle = (s) => ({
    sent:    { color:'#4ade80', label:'✓ Envoyé' },
    sending: { color:'#fbbf24', label:'⟳ En cours' },
    draft:   { color:'#555',    label:'Brouillon' },
  }[s] || { color:'#555', label: s });

  return (
    <div>
      {loading ? <p style={{ color:G.muted }}>Chargement…</p> : campaigns.length === 0
        ? <p style={{ color:G.muted, textAlign:'center', padding:48 }}>Aucune campagne envoyée.</p>
        : campaigns.map(c => {
          const st = statusStyle(c.status);
          return (
            <div key={c.id} style={{ ...card, display:'flex', gap:16, alignItems:'flex-start', flexWrap:'wrap' }}>
              <div style={{ flex:1, minWidth:200 }}>
                <p style={{ margin:'0 0 4px', fontWeight:700, color:G.text, fontSize:'0.9rem' }}>{c.subject}</p>
                <p style={{ margin:'0 0 6px', color:'#555', fontSize:'0.75rem' }}>
                  {c.lists?.join(', ')} · {c.createdAt?.slice(0,10)||'—'}
                </p>
                <p style={{ margin:0, color:'#444', fontSize:'0.78rem', lineHeight:1.5 }}>
                  {c.body?.slice(0,120)}…
                </p>
              </div>
              <div style={{ textAlign:'right', minWidth:120 }}>
                <p style={{ margin:'0 0 4px', color:st.color, fontWeight:700, fontSize:'0.8rem' }}>{st.label}</p>
                <p style={{ margin:0, color:'#4ade80', fontSize:'0.82rem', fontWeight:700 }}>{c.sent||0} envoyés</p>
                {c.failed > 0 && <p style={{ margin:0, color:'#f87171', fontSize:'0.75rem' }}>{c.failed} échoués</p>}
                <p style={{ margin:'4px 0 0', color:'#333', fontSize:'0.72rem' }}>/{c.total||0} total</p>
              </div>
            </div>
          );
        })
      }
    </div>
  );
}

/* ══════════ SECTION PRINCIPALE ══════════ */
export default function MarketingSection() {
  const [tab, setTab]       = useState('abonnes');
  const [refreshKey, setRefreshKey] = useState(0);

  const tabs = [
    { id:'abonnes',   label:'📋 Abonnés'    },
    { id:'importer',  label:'⬆ Importer'    },
    { id:'campagne',  label:'📨 Campagne'    },
    { id:'historique',label:'📊 Historique' },
  ];

  return (
    <div style={{ maxWidth:1100, margin:'0 auto', padding:'32px 24px' }}>
      <div style={{ marginBottom:28 }}>
        <h2 style={{ margin:'0 0 4px', fontSize:'1.4rem', fontWeight:800, color:G.text }}>Mail Marketing</h2>
        <p style={{ margin:0, color:G.muted, fontSize:'0.85rem' }}>Gérez vos abonnés, importez des listes CSV et envoyez des campagnes depuis info@axispme.ca</p>
      </div>

      {/* Onglets */}
      <div style={{ display:'flex', gap:4, marginBottom:28, borderBottom:`1px solid ${G.border}`, paddingBottom:0 }}>
        {tabs.map(t => (
          <button key={t.id} onClick={()=>setTab(t.id)} style={{
            background:'none', border:'none', borderBottom:`2px solid ${tab===t.id ? G.accent : 'transparent'}`,
            color: tab===t.id ? G.accent : G.muted, padding:'10px 18px', fontSize:'0.83rem',
            fontWeight:700, cursor:'pointer', transition:'all 0.15s', marginBottom:-1,
          }}>{t.label}</button>
        ))}
      </div>

      {tab === 'abonnes'    && <OngletAbonnes key={refreshKey} />}
      {tab === 'importer'   && <OngletImporter onImported={()=>{ setRefreshKey(k=>k+1); setTab('abonnes'); }} />}
      {tab === 'campagne'   && <OngletCampagne />}
      {tab === 'historique' && <OngletHistorique />}
    </div>
  );
}
